import {
  Box,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  tableCellClasses,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { useEffect, useState } from "react";
import { LoaderComponent } from "../../../../components/Loader/LoaderComponent";
import useCustomLogic from "../../../../Hooks/UseCustomLogic";
import MariMekkoChart from "../Common/MariMekkoChart";
import { Groups3Outlined, GroupsOutlined } from "@mui/icons-material";
import PopulationPyramidChart from "../Common/DistributionOfLitigantsGraph";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    border: "1px solid #e6ebf4",
    borderBottom: "2px solid #e6ebf4",
    color: "#495057",
    textAlign: "center",
    fontWeight: 600,
  },
  [`&.${tableCellClasses.body}`]: {
    border: "1px solid #e6ebf4",
    textAlign: "center",
    color: "#495057",
  },
}));

export const LitigantProfile = ({ dataState, dataDistrict, selectedDistrict }) => {
  const { isSm } = useCustomLogic();
  const [tableData, setTableData] = useState([]);
  const [chartData, setChartData] = useState([]);
  const [dotGraphKey, setDotGraphKey] = useState(1);
  const { loader } = useCustomLogic();

  useEffect(() => {
    setTableData(dataDistrict);
    setChartData(dataState);
    setDotGraphKey(Math.random());
  }, [dataState, dataDistrict]);

  const normalizeGender = (value) => {
    const normalized = String(value || "").trim().toLowerCase();
    if (normalized.startsWith("m")) return "Male";
    if (normalized.startsWith("f")) return "Female";
    return "NA";
  };

  const normalizeEducation = (value) => {
    const normalized = String(value || "").trim().toLowerCase();
    if (normalized.includes("illiterate")) return "Illiterate";
    if (normalized.includes("basic") || normalized.includes("formal")) return "Basic Literacy";
    if (
      normalized.includes("primary") ||
      normalized.includes("secondary") ||
      normalized.includes("school")
    ) {
      return "Completed School";
    }
    if (normalized.includes("graduate")) return "Graduate & Above";
    return "NA";
  };

  const normalizeDisability = (value) => {
    if (Array.isArray(value)) {
      if (value[0] === "yes" && value[1] === "yes") return "Mobility & Visual";
      if (value[0] === "yes") return "Mobility";
      if (value[1] === "yes") return "Visual";
      return "NA";
    }
    const normalized = String(value || "").trim().toLowerCase();
    if (!normalized || normalized === "no" || normalized === "none" || normalized === "na") {
      return "NA";
    }
    return value;
  };

  return (
    <>
      {loader ? (
        <LoaderComponent height="50vh" />
      ) : (
        <Box>
          {selectedDistrict === "Select District" ? (
            <>
              <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                border="1px solid #e0e0e0"
                borderRadius="3px"
                padding="24px"
                maxWidth="400px"
                mx="auto"
                mb={4}
                boxShadow={1}
              >
                {/* Left bracket and icon */}
                <Box display="flex" alignItems="center" color="#d3d3d3" fontSize="32px">
                  <GroupsOutlined sx={{ fontSize: 80, color: "#d3d3d3" }} />
                </Box>

                {/* Center content */}
                <Box textAlign="center" mx={3}>
                  <Typography
                    variant="subtitle2"
                    fontWeight="bold"
                    color="text.primary"
                    textTransform="uppercase"
                  >
                    Total Litigants Interviewed
                  </Typography>
                  <Typography variant="h2" fontWeight="300" color="text.primary" mt={1}>
                    {dataState?.key_stats?.litigants_surveyed}
                  </Typography>
                </Box>
              </Box>
              <PopulationPyramidChart chartData={chartData} />

              <Typography variant="h3">Education Levels Of Litigants Interviewed </Typography>
              <div
                style={{
                  width: "auto",

                  overflowX: isSm ? "auto" : "none",
                }}
              >
                {/* {Array.isArray(chartData) && ( */}
                <MariMekkoChart key={dotGraphKey} chartData={chartData} />
                {/* )} */}
              </div>
            </>
          ) : (
            <TableContainer>
              <Table aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <StyledTableCell>Age</StyledTableCell>
                    <StyledTableCell>Gender</StyledTableCell>
                    <StyledTableCell>Education</StyledTableCell>
                    <StyledTableCell>Disability</StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {Array.isArray(tableData) &&
                    tableData?.map((row, index) => {
                      return (
                        <TableRow key={index}>
                          <StyledTableCell component="th" scope="row">
                            {row?.litigant_age ?? row?.age ?? "NA"}
                          </StyledTableCell>
                          <StyledTableCell>
                            {normalizeGender(row?.litigant_gender ?? row?.gender)}
                          </StyledTableCell>
                          <StyledTableCell>
                            {normalizeEducation(row?.litigant_education ?? row?.education)}
                          </StyledTableCell>
                          <StyledTableCell>
                            {normalizeDisability(row?.disability)}
                          </StyledTableCell>
                        </TableRow>
                      );
                    })}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </Box>
      )}
    </>
  );
};

// const tableData = [
//   {
//     Age: "30",
//     Gender: "Male",
//     Education: "Completed School",
//     Disability: "NA",
//   },

//   {
//     Age: "70",
//     Gender: "Male",
//     Education: "illiterate",
//     Disability: "NA",
//   },

//   {
//     Age: "25",
//     Gender: "Male",
//     Education: "Graduate & Above",
//     Disability: "NA",
//   },

//   {
//     Age: "26",
//     Gender: "Male",
//     Education: "Graduate & Above",
//     Disability: "NA",
//   },

//   {
//     Age: "43",
//     Gender: "Male",
//     Education: "Graduate & Above",
//     Disability: "NA",
//   },

//   {
//     Age: "34",
//     Gender: "Male",
//     Education: "Graduate & Above",
//     Disability: "NA",
//   },

//   {
//     Age: "25",
//     Gender: "Male",
//     Education: "Completed School",
//     Disability: "NA",
//   },

//   {
//     Age: "29",
//     Gender: "Feale",
//     Education: "Completed School",
//     Disability: "NA",
//   },

//   {
//     Age: "25",
//     Gender: "Male",
//     Education: "Graduate & Above",
//     Disability: "NA",
//   },

//   {
//     Age: "30",
//     Gender: "Female",
//     Education: "Graduate & Above",
//     Disability: "NA",
//   },
// ];
